import { render, staticRenderFns } from "./DevolucionBodegaInformacion.vue?vue&type=template&id=6768e11e"
import script from "./DevolucionBodegaInformacion.vue?vue&type=script&lang=js"
export * from "./DevolucionBodegaInformacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports